import { render, staticRenderFns } from "./JustificativaVazia.vue?vue&type=template&id=1999baa2&scoped=true"
import script from "./JustificativaVazia.vue?vue&type=script&lang=js"
export * from "./JustificativaVazia.vue?vue&type=script&lang=js"
import style0 from "./JustificativaVazia.vue?vue&type=style&index=0&id=1999baa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1999baa2",
  null
  
)

export default component.exports